<flat-pickr v-bind="$attrs" :config="config" :name="name" ref="flatPicker" :id="id"></flat-pickr><slot :picker="flatPicker"></slot>